import { render, staticRenderFns } from "./ExamMarkReviewPage.vue?vue&type=template&id=43951870&scoped=true&"
import script from "./ExamMarkReviewPage.vue?vue&type=script&lang=js&"
export * from "./ExamMarkReviewPage.vue?vue&type=script&lang=js&"
import style0 from "./ExamMarkReviewPage.vue?vue&type=style&index=0&id=43951870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43951870",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
